<script>
import _ from 'lodash'
export default {
	lang: 'books',
	inject: ['editor'],
	data() {
		return {
			tabIndex: -1,
		}
	},
	computed: {
		e() {
			return this.editor()
		},
		tabs() {
			let data = this.e.customization.data
			let { $lang } = this
			return [
				{
					title: $lang('Nombre'),
					get value() {
						return data.name
					},
					incompleteValue: $lang('Completa los datos'),
					get complete() {
						return data.name && data.name2 && data.gender && data.lang
					},
				},
				{
					title: $lang('Dedicatoria'),
					get value() {
						return data.inscription
					},
					incompleteValue: $lang('Escribe una dedicatoria'),
					get complete() {
						return data.inscription
					},
				},
			]
		},
		dataChecker() {
			let data = this.e.customization.data
			let checker = _.pick(data, ['name', 'name2', 'gender', 'lang', 'inscription'])
			return JSON.stringify(checker)
		},
	},
}
</script>

<template>
	<BookEditor-Tabs :tabs="tabs" :data-checker="dataChecker" v-model="tabIndex">
		<template #item1>
			<div class="pr-md-6 w100">
				<BookEditorInput-TextField
					model-key="name"
					:label="$lang('Este libro personalizado es para')"
					:placeholder="$lang('Nombre')"
				/>
				<BookEditorInput-TextField
					model-key="name2"
					:label="$lang('Compañero de aventura')"
					:placeholder="$lang('Nombre')"
					:hint="$lang('Nombre del protagonista masculino, adulto mediana edad.')"
					persistent-hint
				/>
			</div>
			<div class="pt-4 pt-md-0 w100">
				<BookEditorInput-LangSelect />
				<BookEditorInput-GenderCharacters />
			</div>
		</template>
		<template #item2>
			<BookEditorTab-Inscription />
		</template>
	</BookEditor-Tabs>
</template>
